import { render, staticRenderFns } from "./CurrencySummaryGaugeChart.vue?vue&type=template&id=3831630f&scoped=true&"
import script from "./CurrencySummaryGaugeChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./CurrencySummaryGaugeChart.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831630f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
